import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ParticipationOverallComponent} from './participation-overall.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";


@NgModule({
  declarations: [ParticipationOverallComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [ParticipationOverallComponent]
})
export class ParticipationOverallModule {
}
